import axios from 'axios';
import { Logger } from '@smiles/core-engine';

interface EnvironmentClientKey {
  [key: string]: string;
}

const WINDOW = window as unknown as {
  smlsEnv: string;
  isDotEnv: string;
};

const EnvironmentClientKey: EnvironmentClientKey = {
  'DEV1-N': '65fdc785e85a1e0f5c651288',
  'DEV2-N': '65fdc799f3683d0f807ea6e5',
  'DEV3-N': '65fdc7c1dee0dc0fb8ba30e9',
  HML1: '65fdc7ce554b5c0fda14c420',
  HML5: '65fdc7d84dcf1e101bff77d8',
  BLUE: '65fdc7e1e85a1e0f5c6512aa',
  GREEN: '65fdc7f108d1270f6ea7c8ce',
  PRD: '65fdc7f108d1270f6ea7c8ce',
};

const FileEnvironment = async (): Promise<string> => {
  try {
    const timestamp = new Date().getTime();
    const checkEnv = await axios.get('https://www.smiles.com.br/mfe-apps/check-env.txt', {
      params: {
        t: timestamp,
      },
    });
    return checkEnv.data;
  } catch (error) {
    Logger.error(`LaunchDarklyFileEnvironment: ${error}`);
    return 'green';
  }
};

const GetCurrentEnvironment = async (): Promise<string> => {
  const smlsEnv = WINDOW.smlsEnv as string;
  const isDotEnv = WINDOW.isDotEnv as string;
  const currentEnviroment = String(smlsEnv + (isDotEnv ? '-N' : '')).toUpperCase();

  let ENV_CORE = currentEnviroment;
  let clientKey = null;

  if (currentEnviroment.includes('PRD')) {
    ENV_CORE = await FileEnvironment();
  } else if (currentEnviroment.includes('UAT') || currentEnviroment.includes('HML')) {
    ENV_CORE = currentEnviroment.replace('UAT', 'HML');
  }

  ENV_CORE = ENV_CORE.toLocaleUpperCase();

  clientKey = EnvironmentClientKey[ENV_CORE];

  Logger.info('[LDConfig] using', [clientKey ? ENV_CORE : 'PRD']);

  return clientKey || EnvironmentClientKey.PRD;
};

const GetEnv = async (): Promise<string> => {
  const smlsEnv = WINDOW.smlsEnv.toLowerCase() as string;

  let env = smlsEnv;

  if (smlsEnv.includes('prd')) {
    const prodEnv = await FileEnvironment();
    env = `-${prodEnv}`;
  }

  if (smlsEnv.includes('uat') || smlsEnv.includes('hml')) {
    env = '-hml5';
  }

  if (smlsEnv.includes('dev')) {
    env = `.${smlsEnv}`;
  }

  return env;
};

const GetRelayBaseUrl = async (): Promise<string> => {
  const env = await GetEnv();

  const baseUrl = `https://ldrelay${env}.smiles.com.br`;

  return baseUrl;
};

export const LDConfig = {
  GetCurrentEnvironment,
  EnvironmentClientKey,
  GetRelayBaseUrl,
};
